import { useState } from 'react'
import CampoMoeda from '../../componentes/CampoMoeda'
import { formatarMoeda } from '../../lib/formatos'
import { converterNumeroBR } from '../../lib/textoBR'
import { aceitaDigitacao, valorConferido } from '../../comissoes/conferencia'
import { textoIlegivel } from '../../comissoes/listaDaConferencia'

// Spec 2026-10-04 (Baixa de Comissao) §4, decisao dela: o valor da linha fica
// fixo e TOCAR NA LINHA abre esta janela para digitar o que a fabrica pagou.
// Nada e gravado aqui: Salvar so devolve o texto para a tela, e quem grava
// continua sendo o "Dar baixa" -- igual ao campo que existia dentro da linha.
export default function JanelaValorPago({ rotulo, devido, texto, aoSalvar, aoFechar }: {
  rotulo: string
  devido: number
  texto: string | undefined
  aoSalvar: (texto: string | undefined) => void
  aoFechar: () => void
}) {
  const [digitado, setDigitado] = useState(texto ?? devido.toFixed(2).replace('.', ','))
  const usado = valorConferido(devido, digitado)

  // O mesmo aviso de antes: quando o que esta escrito NAO e o numero que vai ser
  // gravado, dizer qual e. Sem isto o texto invalido grava o valor CHEIO calado
  // ("vale R$ 40,00" soava, nas palavras dela, "como se estivesse tudo certo").
  const aviso = converterNumeroBR(digitado) === usado
    ? undefined
    : digitado === ''
      ? `vazio grava ${formatarMoeda(usado)}`
      : 'não entendi — corrija o valor para salvar'

  // Recusar a tecla em vez de aceitar e avisar depois -- pedido dela no smoke.
  function digitar(novo: string) {
    if (aceitaDigitacao(novo)) setDigitado(novo)
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end" onClick={aoFechar}>
      <div
        role="dialog" aria-modal="true" aria-label="Valor pago"
        className="w-full bg-white rounded-t-2xl p-4 pb-6 space-y-3" onClick={(e) => e.stopPropagation()}
      >
        <p className="text-base font-semibold text-slate-800 break-words">{rotulo}</p>
        <p className="text-sm text-slate-600">Devido <span className="font-semibold">{formatarMoeda(devido)}</span></p>
        <label className="block text-sm text-slate-700">
          Valor pago pela fábrica
          <CampoMoeda
            aria-label={`Valor de ${rotulo}`}
            value={digitado}
            onChange={digitar}
            className="mt-1 w-full text-right text-lg border border-slate-300 rounded-lg px-3 py-2"
          />
        </label>
        {aviso && <p className="text-right text-xs text-amber-700">{aviso}</p>}
        {Math.abs(usado - devido) > 0.004 && (
          <button type="button" onClick={() => aoSalvar(undefined)} className="w-full text-sm text-teal-700 underline underline-offset-2">
            Voltar ao devido
          </button>
        )}
        <div className="grid grid-cols-2 gap-3">
          <button type="button" onClick={aoFechar} className="rounded-lg border border-slate-300 py-3 font-semibold text-slate-700">
            Cancelar
          </button>
          {/* Ilegivel nao salva: salvo, gravava o devido e o aviso sumia ao fechar. */}
          <button
            type="button" disabled={textoIlegivel(digitado)} onClick={() => aoSalvar(digitado)}
            className="rounded-lg bg-teal-700 py-3 font-semibold text-white disabled:bg-slate-300"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  )
}
